import { InvoicesService, IGrossAllowanceAccountAudit } from "../../services/index";

class ReportsGrossAllowanceController implements ng.IComponentController {
    from: Date;
    till: Date;
    rows: IGrossAllowanceAccountAudit[] = [];
    filteredRows: IGrossAllowanceAccountAudit[] = [];
    loading = false;
    onlyIssues = true;

    constructor(private InvoicesService: InvoicesService) {
        "ngInject";
    }

    $onInit = () => {
        const moment = require("moment");
        this.from = moment().startOf("month").toDate();
        this.till = moment().endOf("month").toDate();
    };

    search = () => {
        this.loading = true;
        this.InvoicesService.getGrossAllowanceAudit(this.from, this.till)
            .then((result) => {
                this.rows = result || [];
                this.applyFilter();
            })
            .finally(() => {
                this.loading = false;
            });
    };

    applyFilter = () => {
        if (!this.onlyIssues) {
            this.filteredRows = this.rows.slice();
            return;
        }
        this.filteredRows = this.rows.filter((r) => r.status !== "Ok" && r.status !== "NoActivity");
    };

    statusLabel = (status: string) => {
        switch (status) {
            case "Missing": return "Ontbreekt op factuur";
            case "ShouldNotInvoice": return "Ten onrechte gefactureerd";
            case "AmountMismatch": return "Bedrag afwijkend";
            case "Ok": return "OK";
            case "NoActivity": return "Geen bruto in periode";
            default: return status || "—";
        }
    };

    statusClass = (status: string) => {
        switch (status) {
            case "Missing": return "label-warning";
            case "ShouldNotInvoice": return "label-danger";
            case "AmountMismatch": return "label-warning";
            case "Ok": return "label-success";
            default: return "label-default";
        }
    };

    countByStatus = (status: string) => {
        return (this.rows || []).filter((r) => r.status === status).length;
    };
}

export const reportsGrossAllowanceComponent: ng.IComponentOptions = {
    controller: ReportsGrossAllowanceController,
    template: require("./reportsGrossAllowance.html")
};



// WEBPACK FOOTER //
// ./src/app/modules/reports/reportsGrossAllowance.component.ts